/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {Vue, Component} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {Mall, PutOrderOptionHoldDeliveryRequest, PutOrderOptionChangeStatusRequest, OrderStatusType, PostOrderOptionsCheckDivideShippingRequest} from 'supporter';
import $ from 'jquery';
import {getCookie} from '@/utils/cookieUtils';
import { difference, head } from 'lodash';
import {formatCurrency} from '@/utils/formatUtils';

export type CustomGroupFlagCallback<T> = (item: T, originFlag: string) => string;

export type CustomGroupFlagCallbackInfo<T = any> = Partial<Record<'big'| 'middle' | 'small', CustomGroupFlagCallback<T>>>

const mergedRows = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'recommenderId', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'] as const;

@Component
export default class OrderGridsColumns extends Vue {
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  public size: number = 30;
  public ifExchange: boolean = false;
  public listColumns: any;
  public label: string;
  public gridProps: any;
  public tabProductList: any;
  public deliveryCompanyTypeArr?: any;

  protected getMallName(e: any): any {
    if (this.malls.length === 0) {
      return;
    }
    let name = this.malls.filter((item: any): any => {
      return item.mallNo === e;
    });
    if (name.length > 0) {
      return name[0].mallName;
    } else {
      return '_';
    }
  }

  public async getGridDataLayer(callback: Function): Promise<any> {
    let label = this.$route.name;
    if(label === 'DeliveryPrepare') {
      if(getCookie('orderDeliveryPrepareTab') === 'false') {
        label = 'DeliveryPrepare2'
      }
    }
    let gridName: any = this.gridName(label);
    await this.$api.getGridLayouts({params: {gridName: gridName}}).then((request: any) => {
      callback(request);
    });
  }

  public gridName(name): string {
    switch (name) {
      case 'OrderListDeposit':
        return 'ORDER_DEPOSIT_WAIT_GRID';

      case 'OrderList':
        return 'ORDER_LIQUOR_INFO_AGREEMENT_GRID';

      case 'OrderPayDone':
        return 'ORDER_PAY_DONE_GRID'

      case 'OrderProductPrepare':
        return 'ORDER_PRODUCT_PREPARE_GRID'

      case 'DeliveryPrepare':
        return 'ORDER_DELIVERY_PREPARE_GRID'

      case 'DeliveryPrepare2':
        return 'ORDER_DELIVERY_PREPARE_TAB2_GRID'

      case 'OrderDeliverying':
        return 'ORDER_DELIVERY_ING_GRID'

      case 'OrderDeliveryDone':
        return 'ORDER_DELIVERY_DONE_GRID'

      case 'OrderBuyConfirm':
        return 'ORDER_BUY_CONFIRM_GRID'

      case 'OrderPayFail':
        return 'ORDER_PAY_FAIL_GRID'

      case 'OrderHoldDelivery':
        return 'ORDER_HOLD_DELIVERY_GRID'

      case 'OrderHoldByReservation':
        return 'ORDER_HOLD_BY_RESERVATION_GRID'

      case 'holdByReservation':
        return 'ORDER_HOLD_BY_RESERVATION_GRID'

      case 'claimListCancel':
        return 'CLAIM_CANCEL_GRID'

      case 'claimListExchange':
        return 'CLAIM_EXCHANGE_GRID'

      case 'claimListRETURN':
        return 'CLAIM_RETURN_GRID'

    }
  }

  protected getKorCurrency(value: any): any {
    if (!value || isNaN(value)) {
      return 0;
    }
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  public gridHidden(type: boolean) {
    return type !== true;
  }

  public getGridRefactory(str: string, type: boolean = true, displayOrder: number) {
    let getGridRefactory;
    switch (str) {
      case 'platformType':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_PLATFORM_TYPE',
          name: 'platformType',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '플랫폼구분',
          formatter: function (data: any): any {
            if (data.value) {
              if(data.value === 'MOBILE_WEB') {
                return window.$t('ORDER_LIST_GRIDS_PLATFORM_TYPE_MOBILE_WEB');
              } else if(data.value === 'MOBILE_APP') {
                return window.$t('ORDER_LIST_GRIDS_PLATFORM_TYPE_MOBILE_APP');
              } else {
                return data.row.platformTypeLabel;
              }
            }
            return '-';
          }
        }
        break;
      case 'mallNo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_MALLNO',
          name: 'mallNo',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '쇼핑몰구분',
          formatter: (data: any): any => {
            return this.getMallName(data.value);
          }
        }
        break;
      case 'orderRegisterType':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_REGISTER_TYPE',
          name: 'orderRegisterType',
          align: 'center',
          minWidth: 60,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주문구분',
          formatter: function (data: any): any {
            if (data.value) {
              return data.row.orderRegisterTypeLabel;
            }
            return '-';
          }
        }
        break;
      case 'reservation':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RESERVATION_YN',
          name: 'reservation',
          align: 'center',
          minWidth: 60,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '예약주문',
          formatter: function (data: any): any {
            if (data.value === true) {
              return 'Y';
            }
            return '-';
          },
        }
        break;
      case 'memberGroupInfoJson':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_MEMBER_GROUP_INFO_JSON',
          name: 'memberGroupInfoJson',
          align: 'center',
          minWidth: 60,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '회원그룹',
          formatter: function (data: any): any {
            if (!data || data.value === '' || data.value === '[]') {
              return '-';
            }
            const memberGroupInfo = JSON.parse(data.value);
            if (memberGroupInfo === null || memberGroupInfo.length <= 0) {
              return '-';
            } else if (memberGroupInfo.length == 1) {
              return memberGroupInfo[0].memberGroupName;
            }
            return `<a href="javascript:;" class="member-group-name-grid" data-json='${JSON.stringify(memberGroupInfo).replace(/"/g, '\\"')}'>${memberGroupInfo[0].memberGroupName}</a>`;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: function (data: any): any {
              if (!data) {
                return '-';
              }
              const memberGroupInfo = JSON.parse(data);
              if (memberGroupInfo === null || memberGroupInfo.length <= 0) {
                return '-';
              } else if (memberGroupInfo.length == 1) {
                return memberGroupInfo[0].memberGroupName;
              }
            }
          }
        }
        break;
      case 'recommenderId':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RECOMMENDER_ID',
          name: 'recommenderId',
          align: 'center',
          minWidth: 60,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '추천인',
          formatter: function (data: any): any {
            return !data.value ? '-' : data.value;
          }
        }
        break;
      case 'payType':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_PAY_TYPE',
          align: 'center',
          minWidth: 80,
          name: 'payType',
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '결제수단',
          formatter: function (data: any): string {
            return data.row.payTypeLabel;
          },
        }
        break;
      case 'orderNo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_NO',
          align: 'center',
          minWidth: 160,
          name: 'orderNo',
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주문번호',
          copyOptions: {
            useFormattedValue: true,
            customValue: value => value
          }
        }
        if(this.label !== 'OrderPayFail') { // 결제실패
          getGridRefactory.formatter =
            (data: any): any => {
              const naverPayDiv = data.row.payType === 'NAVER_PAY' ? `<div> (N: ${data.row.externalOrderNo})</div>` : '';
              if (data.row.orderStatusType === 'PAY_CANCEL' || data.row.orderStatusType === 'PAY_FAIL') {
                return data.value + naverPayDiv;
              }
              const hold = data.row.hold;
              let className = '';
              if (hold === true) {
                className = 'hold';
              }
              return `<a href="/order/detail?orderNo=${data.value}" target="_blank" class=${className}>${data.value}</a> ${naverPayDiv}`;
            }
        }
        break;
      case 'ordererName':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_NAME',
          align: 'center',
          minWidth: 80,
          name: 'ordererName',
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주문자명',
          formatter: (data: any) => {
            const memberNo = data.row.memberNo || 0;
            return memberNo === 0 ? data.value : `<a href="javascript:;" class="ordererPopup" data-memberno="${memberNo}">${data.value}</a>`;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: value => value
          }
        }
        break;
      case 'ordererContact1':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_CONTACT1',
          align: 'center',
          minWidth: 100,
          name: 'ordererContact1',
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주문자 연락처',
          copyOptions: {
            useFormattedValue: true,
            customValue: value => value
          }
        }
        break;
      case 'holdDelivery':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_HOLD_DELIVERY_YN',
          name: 'holdDelivery',
          align: 'center',
          minWidth: 60,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '배송보류',
          formatter: function (data: any): any {
            if (!data.value || data.value === false) {
              return '-';
            }
            return 'Y';
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: function (data: any): any {
              if (!data || data === false) {
                return '-';
              }
              return 'Y';
            }
          }
        }
        break;
      case 'memberNo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_MEMBER_NO',
          align: 'center',
          minWidth: 80,
          name: 'memberNo',
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '회원번호',
          formatter: function (data: any): any {
            if (data.value === 0) {
              return '-';
            }
            return data.value;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: function (data: any): any {
              if (data === 0) {
                return '-';
              }
              return data;
            }
          }
        }
        break;
      case 'shippingAreaType':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_SHIPPING_ARER_TYPE_LABEL',
          name: 'shippingAreaType',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '배송구분',
          formatter: function (data: any): any {
            if (data.value === 'PARTNER_SHIPPING_AREA') {
              return window.$t('ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_PARTNER_SHIPPING_AREA');
            } else if (data.value === 'MALL_SHIPPING_AREA') {
              return window.$t('ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_MALL_SHIPPING_AREA');
            } else {
              return '';
            }
          }
        }
        break;
      case 'taskMessage':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_TASK_MESSAGE_YN',
          name: 'taskMessage',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '업무메시지',
          formatter: (data: any): any => {
            const {taskMessageCnt, taskMessageProcessCnt} = data.row;
            // taskMessageCnt > 0 이면 처리중으로 표시
            if (taskMessageCnt === 0) {
              return '';
            }

            if (taskMessageProcessCnt > 0) {
              return `<a href="/order/detail?orderNo=${data.row.orderNo}" target="_blank" data-order-no="${data.row.orderNo}" class="taskMessageBtn taskMseeageBtnImg" style="width: 18px; height: 18px; margin-top: 2px; display: inline-block; "></a>`;
            }

            return `<a href="/order/detail?orderNo=${data.row.orderNo}" target="_blank" data-order-no="${data.row.orderNo}" class="taskMessageBtn taskMseeageCompleteBtnImg" style="width: 18px; height: 18px; margin-top: 2px; display: inline-block; "></a>`;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: (data: any): any => {
              if (data === true) {
                return 'Y';
              } else {
                return '';
              }
            }
          }
        }
        break;
      case 'orderStatusType':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_STATUS_TYPE',
          align: 'center',
          minWidth: 80,
          name: 'orderStatusType',
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주문상태',
        }
        if(this.label === 'OrderPayFail') { // 결제실패
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_ORDER_STATUS_TYPE_THREE'

          getGridRefactory.formatter =
            (data: any): any => {
              if (data.row.orderStatusType == 'PAY_FAIL') {
                return `<font color="red">${window.$t('ORDER_LIST_GRIDS_HEADER_OTHER_STATUS_TYPE_LABEL')}</font>`;
              }

              return window.$t('ORDER_LIST_GRIDS_HEADER_OTHER_STATUS_TYPE_LABEL_ELSE');
            }
        } else {
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_ORDER_STATUS_TYPE'
          getGridRefactory.formatter =
            (data: any): any => {
              if (data.row.orderStatusType === 'CANCEL_DONE') {
                return data.row.orderStatusTypeLabel;
              }

              const holdDeliveryLabel = data.row.holdDelivery ? `<br/>[${window.$t('ORDER_LIST_GRIDS_HEADER_HOLD_DELIVERY_YN')}]` : '';

              return data.row.orderStatusTypeLabel + holdDeliveryLabel;
            }
        }
        break;
      case 'failInfo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_FAIL_INFO',
          align: 'center',
          minWidth: 300,
          name: 'failInfo',
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '실패사유',
          formatter: (data: any): any => {
            if (data.row.orderStatusType == 'PAY_FAIL') {
              return data.row.failInfo;
            }
            return '';
          },
        }
        break;
      case 'claimStatusType':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_CLAIM_STATUS_TYPE',
          align: 'center',
          minWidth: 135,
          name: 'claimStatusType',
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '클레임상태',
          formatter: function (data: any): any {
            if (!data.value) {
              return '-';
            }
            return data.row.claimStatusTypeLabel;
          },
        }
        break;
      case 'partnerNo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_PARTER_NO',
          name: 'partnerNo',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '파트너사',
          formatter: function (data: any): any {
            return data.row.partnerName;
          },
        }
        break;
      case 'hsCode':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_HS_CODE',
          name: 'hsCode',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: 'HS CODE',
        }
        break;
      case 'mallProductNo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_MALL_PRODUCT_NO',
          name: 'mallProductNo',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '상품번호',
        }
        break;
      case 'productManagementCd':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_PRODUCT_MANAGEMENT_CD',
          name: 'productManagementCd',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '상품관리코드',
        }
        break;
      case 'imageUrl':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_PRODUCT_IMAGE',
          name: 'imageUrl',
          align: 'center',
          minWidth: 150,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '상품 이미지',
          formatter: ({ value }) => value ? `<img src="${value}" alt="thumbnail" class="product-image" />` : '-'
        }
        break;
      case 'productName':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_PRODUCT_NAME',
          name: 'productName',
          align: 'left',
          minWidth: 200,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '상품명',
          formatter: ({ row, value }) => {
            const exchangeTag =  `<span class="tag blue">${window.$t('ORDER_LIST_GRIDS_EXCHANGE_FORWARDING')}</span>`;

            if (row.isSetOption) {
              const setTag = `<span class="tag pink">${window.$t('ORDER_LIST_GRIDS_PRODUCT_NAME_TAG')}</span>`;

              return row.exchange ? `${exchangeTag}${setTag}${value}` : `${setTag}${value}`;
            }
            if (row.isFreeGift) {
              const button = row.freeGiftConditionBrokenType === 'CLAIM_DONE' ? '<button class="alert-exclamation"></button>' : '';
              const freeGiftTag = `<span class="green-badge">사은품</span>${ button }`;

              return row.exchange ? `${exchangeTag}${freeGiftTag}${value}` : `${freeGiftTag}${value}`;
            }
            if (row.exchange) {
              return `${exchangeTag}${value}`;
            }
            return value;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: value => value
          }
        }
        break;
      case 'productNameEn':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_PRODUCT_NAME_EN',
          name: 'productNameEn',
          align: 'left',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '영문상품명',
        }
        break;
      case 'optionManagementCd':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_OPTION_MANAGEMENT_CD',
          name: 'optionManagementCd',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '옵션관리코드',
        }
        break;
      case 'displayOptionName':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DISPLAY_OPTION_NAME',
          name: 'displayOptionName',
          align: 'left',
          minWidth: 150,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '옵션명: 옵션값',
          formatter: function (data: any): any {
            const mallAdditionalProductNo = data.row.mallAdditionalProductNo;
            if (parseInt(mallAdditionalProductNo) > 0) {
              return `<span class="tag orange"> ${window.$t('ORDER_LIST_GRIDS_ADD')}</span> ${data.value}`;
            }
            return data.value;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: value => value
          }
        }
        break;
      case 'immediateDiscountedPrice':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_IMMEDIATE_DISCOUNT_PRICE',
          name: 'immediateDiscountedPrice',
          align: 'right',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '판매가(할인적용가)',
          formatter: (data: any): any => {
            return this.getKorCurrency(data.value);
          },
        }
        break;
      case 'additionalDiscountAmt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ADDITIONAL_DISCOUNT_AMT',
          name: 'additionalDiscountAmt',
          align: 'right',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '추가할인',
          formatter: (data: any): any => {
            return this.getKorCurrency(data.value);
          },
        }
        break;
      case 'freeGiftDiscountAmt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_FREE_GIFT_DISCOUNT_AMT',
          name: 'freeGiftDiscountAmt',
          align: 'right',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '사은품 할인',
          formatter: (data) => this.getKorCurrency(data.value),
        }
        break;
      case 'buyPrice':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_BUY_PRICE',
          name: 'buyPrice',
          align: 'right',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: (data: any): any => {
            return this.getKorCurrency(data.value);
          },
        }
        break;
      case 'orderCnt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_CNT',
          name: 'orderCnt',
          align: 'center',
          minWidth: 30,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '수량',
          formatter: (data: any): any => {
            // return this.getKorCurrency(data.value);
            if (data.value > 1) {
              return `<span class="highlight">${data.value}</span>`;
            }

            return data.value;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: value => value
          }
        }
        break;
      case 'totalBuyAmt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_TOTAL_BUY_AMT',
          name: 'totalBuyAmt',
          align: 'right',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '상품합계',
          formatter: (data: any): any => {
            return this.getKorCurrency(data.value);
          },
        }
        break;
      case 'receiverName':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RECEIVER_NAME',
          name: 'receiverName',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '수령자명',
        }
        break;
      case 'receiverContact1':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RECEIVER_CONTACT1',
          name: 'receiverContact1',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '수령자휴대전화',
        }
        break;
      case 'receiverZipCd':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RECEIVER_ZIP_CD',
          name: 'receiverZipCd',
          align: 'center',
          minWidth: 60,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '우편번호',
        }
        break;
      case 'address':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ADRESS',
          name: 'address',
          align: 'left',
          minWidth: 200,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주소',
        }
        break;
      case 'shippingNo': // shippingNo??? 
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DELIVER_NO',
          name: 'shippingNo',
          align: 'center',
          minWidth: 150,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '배송번호',
          whiteSpace: 'nowrap',
          maxHeight: 40,
          formatter: (data: any): any => {
            if (data.row.combineDelivery === true) {
              return `<div>${data.value} <br/><span class="tag yellow" style="padding-bottom: 0px;">${window.$t('ORDER_LIST_GRIDS_DELIVERY_NUIT')}</span></div>`;
            } else if (data.row.divideDelivery === true) {
              return `${data.value} <span class="tag orange" style="padding-bottom: 0px;">${window.$t('ORDER_LIST_GRIDS_SHARE')}</span>`;
            }
            return data.value;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: value => value
          }
        }
        break;
      case 'deliveryAmtInAdvance':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DELIVER_AMT_ADVANCE_YN',
          name: 'deliveryAmtInAdvance',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '결제방식', // 배송비 결제방식
          formatter: function (data: any): any {
            if (data.row.delivery === false) {
              return '-';
            }
            return data.value === false ? `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_ARRIVE')}` : `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_BEFORE')}`;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: function (data: any): any {
              return data === false ? `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_ARRIVE')}` : `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_BEFORE')}`;
            }
          }
        }
        break;
      case 'deliveryConditionType':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DELIVER_CONDITION_TYPE',
          name: 'deliveryConditionType',
          align: 'center',
          minWidth: 110,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '배송비 유형',
          formatter: function (data: any): any {
            if (!data.value) {
              return '-';
            }
            return data.row.deliveryConditionTypeLabel;
          },
        }
        break;
      case 'customsIdNumber':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_CUSTOMS_ID_NUMBER',
          name: 'customsIdNumber',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '개인통관고유부호',
        }
        break;
      case 'deliveryType':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DELIVER_TYPE',
          name: 'deliveryType',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '배송방법',
          formatter: function (data: any): any {
            if (!data.value) {
              return '-';
            }
            return data.row.deliveryTypeLabel;
          },
        }
        break;
      case 'deliveryCompanyType':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DELIVER_COMPANY_TYPE',
          name: 'deliveryCompanyType',
          align: 'center',
          minWidth: 110,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '택배사',
        }
        if(this.label === 'DeliveryPrepare' && getCookie('orderDeliveryPrepareTab') === 'true') { // 배송준비중
          getGridRefactory.formatter =
            (data: any): any => {
              let theOpt = '';
              let theSelect = '';
              let content = '';
              if (this.deliveryCompanyTypeArr.length > 0) {
                this.deliveryCompanyTypeArr.map((dct: any): any => {
                  if (data.value === dct.deliveryCompanyType) {
                    theOpt += `<option selected value="${dct.deliveryCompanyType}">${dct.label}</option>`;
                  } else {
                    if(dct.deliveryCompanyType === 'CJ') {
                      theOpt += `<option selected value="${dct.deliveryCompanyType}">${dct.label}</option>`;
                    } else {
                      theOpt += `<option value="${dct.deliveryCompanyType}">${dct.label}</option>`;
                    }
                  }
                });
                if (data.row.deliveryType === 'DIRECT_DELIVERY' || data.row.delivery === false) {
                  let name = 'companySelect';
                  theSelect = `<select data-group-key="${data.row.shippingNo}" class="${name}" disabled>${theOpt}</select>`;
                } else {
                  let name = 'companySelect';
                  theSelect = `<select data-group-key="${data.row.shippingNo}" class="${name}">${theOpt}</select>`;
                }
                content = `<span class="tui-grid-content-before"></span><span class="tui-grid-content-after"></span><span class="tui-grid-content-input">${theSelect}</span>`;
              }
              return `${content}`;
            };
        } else {
          getGridRefactory.formatter =
            (data: any): any => {
              return !data.row.deliveryCompanyTypeLabel ? '-' : data.row.deliveryCompanyTypeLabel;
            }
        }
        break;
      case 'invoiceNo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_INVOICE_NO',
          name: 'invoiceNo',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '송장번호',
          formatter: '',
        }
        if(this.label === 'DeliveryPrepare' && getCookie('orderDeliveryPrepareTab') === 'true') { // 배송준비중
          getGridRefactory.formatter =
            (data: any): any => {
              if (data.row.deliveryType === 'DIRECT_DELIVERY' || data.row.delivery === false) {
                return `<input type="text" data-row-key="${data.row.rowKey}" data-column-name="${data.column.name}" data-group-key="${data.row.shippingNo}" class="invoiceNoInput" maxlength disabled value="${data.value}"/>`;
              } else {
                if(data.value === null) data.value = '';
                return `<input type="text" data-row-key="${data.row.rowKey}" data-column-name="${data.column.name}" data-group-key="${data.row.shippingNo}" class="invoiceNoInput" maxlength="50" value="${data.value}"/>`;
              }
            }
        } else {
          getGridRefactory.formatter =
            (data: any): any => {
              return !data.value ? '-' : data.value;
            }
        }
        break;
      case 'liquor':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_LIQUOR_ORDER_AGREE',
          name: 'liquor',
          align: 'center',
          minWidth: 150,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주류구매 정보동의',
          formatter: (data: any): 'Y' | '-' => {
            return data.value ? 'Y' : '-';
          },
        }
        break;
      case 'orderYmdt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_YMDT',
          name: 'orderYmdt',
          align: 'center',
          minWidth: 130,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주문일시',
        }
        break;
      case 'payYmdt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_PAY_YMDT',
          name: 'payYmdt',
          align: 'center',
          minWidth: 130,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '결제일시',
          formatter: function (data: any): any {
            if (!data.value) {
              return '-';
            }
            return data.value;
          },
        }
        break;
      case 'orderAcceptYmdt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_ACCEPT_YMDT',
          name: 'orderAcceptYmdt',
          align: 'center',
          minWidth: 130,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주문접수일시',
          formatter: ({ value }) => value ?? '-',
        }
        break;
      case 'releaseReadyYmdt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RELEASE_READY_YMDT',
          name: 'releaseReadyYmdt',
          align: 'center',
          minWidth: 130,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '출고준비처리일시',
          formatter: ({ value }) => value ?? '-',
        }
        break;
      case 'releaseYmdt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RELEASE_YMDT',
          name: 'releaseYmdt',
          align: 'center',
          minWidth: 130,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '출고일시',
          formatter: function (data: any): any {
            if (!data.value) {
              return '-';
            }
            return data.value;
          },
        }
        break;
      case 'deliveryCompleteYmdt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DELIVER_COMPLETE_YMDT',
          name: 'deliveryCompleteYmdt',
          align: 'center',
          minWidth: 130,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '배송완료일시',
          formatter: function (data: any): any {
            if (!data.value) {
              return '-';
            }
            return data.value;
          },
        }
        break;
      case 'buyConfirmYmdt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_BUY_CONFIRM_YMDT',
          name: 'buyConfirmYmdt',
          align: 'center',
          minWidth: 130,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '구매확정일시',
          formatter: function (data: any): any {
            if (!data.value) {
              return '-';
            }
            return data.value;
          },
        }
        break;
      case 'adjustedAmt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ADJUST_AMT',
          name: 'deliveryAmt',
          align: 'right',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '기본배송비',
          formatter: (data: any): any => {
            if (data.row.deliveryYn === false) {
              return '-';
            }
            return this.getKorCurrency(data.value);
          },
        }
        break;
      case 'remoteDeliveryAmt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_REMOTE_DELIVERY_AMT',
          name: 'remoteDeliveryAmt',
          align: 'right',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '지역별배송비',
          formatter: (data: any): any => {
            if (data.row.deliveryYn === false) {
              return '-';
            }
            return this.getKorCurrency(data.value);
          },
        }
        break;
      case 'exchange':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_EXCHANGE',
          name: 'exchange',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: (data: any): any => {
            if (data.value === true) {
              return 'Y';
            } else {
              return 'N';
            }
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: (data: any): any => {
              if (data === true) {
                return 'Y';
              } else {
                return 'N';
              }
            }
          }
        }
        break;
      case 'orderMemo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_MEMO',
          name: 'orderMemo',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주문메모',
        }
        break;
      case 'procBtn':
        getGridRefactory = {
          header: '',
          align: 'center',
          minWidth: 100,
          name: 'procEachBtn',
          visible: type,
          order: displayOrder,
          i18n: '입금확인처리, 주문접수처리, 출고준비처리, 배송완료, 배송완료처리',
          formatter: '',
        }
        if(this.label === 'OrderPayDone') { // 결제완료
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_ORDER_PAY_DONE_CHANGE_STATUS'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusEach" style="height:20px;" to="DEPOSIT_WAIT" orderProductOptionNo="${data.row.orderProductOptionNo}">${window.$t(
                'ORDER_LIST_GRIDS_PROC_EACH_BTN_ORDER'
              )}</button>`;
            }
        } else if(this.label === 'OrderProductPrepare') { // 상품준비중
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_PROC_EACH_BTN'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusEach" style="height:20px;" to="DELIVERY_PREPARE" orderProductOptionNo="${data.row.orderProductOptionNo}">${window.$t(
                'ORDER_LIST_GRIDS_PROC_EACH_BTN_OUT'
              )}</button>`;
            }
        } else if(this.label === 'DeliveryPrepare') { // 배송준비중
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_DELIVERY_PREPARE_PROC_BTN'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusGroup" style="height:20px;" to="DELIVERY_ING" orderProductOptionNos="${data.row.orderProductOptionNoStr}">${window.$t(
                'ORDER_LIST_GRIDS_DELIVERY_PROC_BTN'
              )}</button>`;
            }
        } else if(this.label === 'OrderDeliverying') { // 배송중
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_ORDER_DELIVER_COMPLETE_CHANGE_STATUS'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusGroup" style="height:20px;" to="DELIVERY_DONE" orderProductOptionNos="${data.row.orderProductOptionNoStr}" orderProductOptionNo="${data.row.orderProductNo}">배송완료</button>`;
            }
        } else if(this.label === 'OrderListDeposit') { // 입금대기
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_ORDER_DELIVER_COMPLETE_CHANGE_STATUS'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusGroup" style="height:20px;" to="PAY_DONE" orderProductOptionNos="${data.row.orderNo}">입금확인</button>`;
            }
        }
        break;
      case 'procEachBtn':
        getGridRefactory = {
          header: '',
          align: 'center',
          minWidth: 100,
          name: 'procEachBtn',
          visible: type,
          order: displayOrder,
          i18n: '입금확인처리, 주문접수처리, 출고준비처리, 배송완료, 배송완료처리',
          formatter: '',
        }
        if(this.label === 'OrderPayDone') { // 결제완료
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_ORDER_PAY_DONE_CHANGE_STATUS'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusEach" style="height:20px;" to="DEPOSIT_WAIT" orderProductOptionNo="${data.row.orderProductOptionNo}">${window.$t(
                'ORDER_LIST_GRIDS_PROC_EACH_BTN_ORDER'
              )}</button>`;
            }
        } else if(this.label === 'OrderProductPrepare') { // 상품준비중
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_PROC_EACH_BTN'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusEach" style="height:20px;" to="DELIVERY_PREPARE" orderProductOptionNo="${data.row.orderProductOptionNo}">${window.$t(
                'ORDER_LIST_GRIDS_PROC_EACH_BTN_OUT'
              )}</button>`;
            }
        } else if(this.label === 'DeliveryPrepare') { // 배송준비중
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_DELIVERY_PREPARE_PROC_BTN'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusGroup" style="height:20px;" to="DELIVERY_ING" orderProductOptionNos="${data.row.orderProductOptionNoStr}">${window.$t(
                'ORDER_LIST_GRIDS_DELIVERY_PROC_BTN'
              )}</button>`;
            }
        } else if(this.label === 'OrderDeliverying') { // 배송중
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_ORDER_DELIVER_COMPLETE_CHANGE_STATUS'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusGroup" style="height:20px;" to="DELIVERY_DONE" orderProductOptionNos="${data.row.orderProductOptionNoStr}" orderProductOptionNo="${data.row.orderProductOptionNo}">배송완료</button>`;
            }
        } else if(this.label === 'OrderListDeposit') { // 입금대기
          getGridRefactory.header = 'ORDER_LIST_GRIDS_HEADER_PROC_BTN'
          getGridRefactory.formatter =
            (data: any): any => {
              return `<button type="button" class="changeStatusGroup" style="height:20px;" to="PAY_DONE" orderProductOptionNos="${data.row.orderNo}">입금확인</button>`;
            }
        }
        break;
      case 'userInputTextStr':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_USER_INPUT_TEXT_STR',
          name: 'userInputTextStr',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '구매자작성형',
        }
        break;
      case 'deliveryMemo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DELIVERY_MEMO',
          name: 'deliveryMemo',
          align: 'center',
          minWidth: 150,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '배송메모',
        }
        break;
      // hold-delivery
      case 'holdDeliveryYmdt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_HOLD_DELIVERY_YMT',
          name: 'holdDeliveryYmdt',
          align: 'center',
          minWidth: 130,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: function (data: any): any {
            if (data.value == null) {
              return '-';
            }

            return data.value;
          },
        }
        break;
      // holdby-reservation
      case 'reservationStartYmdt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RESERVATION_START_YMT',
          name: 'reservationStartYmdt',
          align: 'center',
          minWidth: 150,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
	        formatter: ({ row, value }) => row.isFreeGift ? '-' : value
        }
        break;

      // 추후 삭제할 case
      case 'reservationYn':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RESERVATION_YN',
          name: 'reservation',
          align: 'center',
          minWidth: 60,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: function (data: any): any {
            if (data.value === true) {
              return 'Y';
            }
            return '-';
          },
        }
        break;

      case 'holdDeliveryYn':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_HOLD_DELIVERY_YN',
          name: 'holdDelivery',
          align: 'center',
          minWidth: 60,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: function (data: any): any {
            if (!data.value || data.value === false) {
              return '-';
            }
            return 'Y';
          },
        }
        break;

      case 'shippingAreaTypeLabel':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_SHIPPING_ARER_TYPE_LABEL',
          name: 'shippingAreaType',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: function (data: any): any {
            if (data.value === 'PARTNER_SHIPPING_AREA') {
              return window.$t('ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_PARTNER_SHIPPING_AREA');
            } else if (data.value === 'MALL_SHIPPING_AREA') {
              return window.$t('ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_MALL_SHIPPING_AREA');
            } else {
              return '';
            }
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: function (data: any): any {
              if (data === 'PARTNER_SHIPPING_AREA') {
                return window.$t('ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_PARTNER_SHIPPING_AREA');
              } else if (data === 'MALL_SHIPPING_AREA') {
                return window.$t('ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_MALL_SHIPPING_AREA');
              } else {
                return '';
              }
            }
          }
        }
        break;

      case 'taskMessageYn':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_TASK_MESSAGE_YN',
          name: 'taskMessage',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: (data: any): any => {
            const {taskMessageCnt, taskMessageProcessCnt} = data.row;
            // taskMessageCnt > 0 이면 처리중으로 표시
            if (taskMessageCnt === 0) {
              return '';
            }

            if (taskMessageProcessCnt > 0) {
              return `<a href="/order/detail?orderNo=${data.row.orderNo}" target="_blank" data-order-no="${data.row.orderNo}" class="taskMessageBtn taskMseeageBtnImg" style="width: 18px; height: 18px; margin-top: 2px; display: inline-block; "></a>`;
            }

            return `<a href="/order/detail?orderNo=${data.row.orderNo}" target="_blank" data-order-no="${data.row.orderNo}" class="taskMessageBtn taskMseeageCompleteBtnImg" style="width: 18px; height: 18px; margin-top: 2px; display: inline-block; "></a>`;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: (data: any): any => {
              if (data === true) {
                return 'Y';
              } else {
                return '';
              }
            }
          }
        }
        break;

      case 'deliveryNo': // shippingNo???
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DELIVER_NO',
          name: 'shippingNo',
          align: 'center',
          minWidth: 150,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: (data: any): any => {
            if (data.row.combineDelivery === true) {
              return `<div>${data.value} <br/><span class="tag yellow" style="padding-bottom: 0px;">${window.$t('ORDER_LIST_GRIDS_DELIVERY_NUIT')}</span></div>`;
            } else if (data.row.divideDelivery === true) {
              return `${data.value} <span class="tag orange" style="padding-bottom: 0px;">${window.$t('ORDER_LIST_GRIDS_SHARE')}</span>`;
            }
            return data.value;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: value => value
          }
        }
        break;

      case 'deliveryAmtInAdvanceYn':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_DELIVER_AMT_ADVANCE_YN',
          name: 'deliveryAmtInAdvance',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: function (data: any): any {
            if (data.row.delivery === false) {
              return '-';
            }
            return data.value === false ? `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_ARRIVE')}` : `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_BEFORE')}`;
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: function (data: any): any {
              return data === false ? `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_ARRIVE')}` : `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_BEFORE')}`;
            }
          }
        }
        break;

      case 'exchangeYn':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_EXCHANGE',
          name: 'exchange',
          align: 'center',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: (data: any): any => {
            if (data.value === true) {
              return 'Y';
            } else {
              return 'N';
            }
          },
          copyOptions: {
            useFormattedValue: true,
            customValue: (data: any): any => {
              if (data === true) {
                return 'Y';
              } else {
                return 'N';
              }
            }
          }
        }
        break;

      case 'deliveryAmt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ADJUST_AMT',
          name: 'deliveryAmt',
          align: 'right',
          minWidth: 80,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '기본배송비',
          formatter: (data: any): any => {
            if (data.row.deliveryYn === false) {
              return '-';
            }

            return this.getKorCurrency(data.value);
          },
        }
        break;

      case 'orderOptionNo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_ORDER_OPTION_NO',
          name: 'orderOptionNo',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '주문상품옵션번호',
          formatter: data => {
            return data.row.orderProductOptionNo;
          },
        };
        break;

      case 'recurringPaymentNo':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_RECURRING_PAYMENT_NO',
          name: 'recurringPaymentNo',
          align: 'center',
          minWidth: 150,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          formatter: ({ value }: { value?: string }): string => value ?? '-',
        }
        break;

      case 'lastSubPayAmt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_LAST_SUB_PAY_AMT',
          name: 'lastSubPayAmt',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '적립금사용',
          formatter: ({ value }) => formatCurrency(value),
        };
        break;

      case 'lastMainPayAmt':
        getGridRefactory = {
          header: 'ORDER_LIST_GRIDS_HEADER_TOTAL_PAY_AMT',
          name: 'lastMainPayAmt',
          align: 'center',
          minWidth: 100,
          hidden: this.gridHidden(type),
          visible: type,
          order: displayOrder,
          i18n: '실결제금액',
          formatter: ({ value }) => formatCurrency(value),
        };
        break;

      default :
        getGridRefactory = {
          header: '',
          name: '',
          align: '',
          order: displayOrder,
        }
        break;
    }

    return getGridRefactory;
  };

	/**
	 * big@@, middle@@, small@@ 은 모두 arr[0] -> item 에 존재하는 키 값의 일부임.
	 * - bigGroupFlag, middleGroupFlag, smallGroupFlag 를 기준으로 병합
	 * - 각 flag 를 기준으로 bigRow, midRow, smallRow 배열에 존재하는 키값에 해당되는 cell 을 병합
	 * - CustomGroupFlagCallbackInfo : 사은품의 경우 smallRow 병합 시 flag 가 동적으로 변경되어야하는 요구사항이 있어 추가함
	 *   - big, middle, small 에 flag 값을 동적으로 변경시킬 콜백 정의
	 *
	 * @param arr: any[]  병합할 데이터 (제너릭으로 받고 싶은 타입)
	 * @param bigRow: 병합이 필요한 키[]
	 * @param midRow: 병합이 필요한 키[]
	 * @param smallRow: 병합이 필요한 키[]
	 * @param bigGroupFlag: string
	 * @param middleGroupFlag: string
	 * @param smallGroupFlag: string
	 * @param customGroupFlagCallbackInfo?: CustomGroupFlagCallbackInfo
	 */
  public meargeRow(arr: any, bigRow: any, midRow: any, smallRow: any, bigGroupFlag: string, middleGroupFlag: string, smallGroupFlag: string, customGroupFlagCallbackInfo?: CustomGroupFlagCallbackInfo): any {
    if (arr && arr.length === 0) {
      return;
    }
    let bigGroup: any = [];
    let newArry: any = [];
		let _bigGroupFlag = bigGroupFlag
    arr.forEach(
      (item: any): void => {
				if (customGroupFlagCallbackInfo?.big) {
					_bigGroupFlag = customGroupFlagCallbackInfo.big(item, bigGroupFlag)
				}

        if (bigGroup.indexOf(item[_bigGroupFlag]) < 0) {
          bigGroup.push(item[_bigGroupFlag]);
        }
      }
    );

    bigGroup.forEach(
      (bigItem: any): void => {
        let nums: any = arr.filter(
          (item: any): any => {
            return bigItem === item[_bigGroupFlag];
          }
        );

        let firstRow = true;
        arr.forEach(
          (item: any): void => {
            if (bigItem === item[_bigGroupFlag]) {
              if (firstRow && nums.length > 1) {
                let rowSpanTag = bigRow;
                this.addRowSpan(rowSpanTag, item, nums.length);
                firstRow = false;
              }
              newArry.push(item);
            }
          }
        );

        let middleGroup: any = [];
				let _middleGroupFlag = middleGroupFlag;
        nums.forEach(
          (numItem: any): void => {
						if (customGroupFlagCallbackInfo?.middle) {
							_middleGroupFlag = customGroupFlagCallbackInfo.middle(numItem, middleGroupFlag);
						}

            if (middleGroup.indexOf(numItem[_middleGroupFlag]) < 0) {
              middleGroup.push(numItem[_middleGroupFlag]);
            }
          }
        );
        middleGroup.forEach(
          (smallItem: any): any => {
            let orderNums: any = nums.filter(
              (item1: any): any => {
                return smallItem === item1[_middleGroupFlag];
              }
            );
            let orderFirstRow = true;
            newArry.map(
              (newItem: any): any => {
                if (smallItem === newItem[_middleGroupFlag] && newItem[_bigGroupFlag] === bigItem && orderFirstRow) {
                  let rowSpanTag = midRow;
                  this.addRowSpan(rowSpanTag, newItem, orderNums.length);
                  orderFirstRow = false;
                }
              }
            );
            let smallGroup: any[] = [];
						let _smallGroupFlag = smallGroupFlag;
            orderNums.forEach(
              (sItem: any): any => {
								if (customGroupFlagCallbackInfo?.small) {
									_smallGroupFlag = customGroupFlagCallbackInfo.small(sItem, smallGroupFlag);
								}

                if (smallGroup.indexOf(sItem[_smallGroupFlag]) < 0) {
                  smallGroup.push(sItem[_smallGroupFlag]);
                }
              }
            );
            smallGroup.forEach(
              (smItem: any): any => {
                let length = orderNums.filter(
                  (item2: any): any => {
                    return smItem === item2[_smallGroupFlag];
                  }
                ).length;
                let smallFirstRow = true;
                newArry.map(
                  (smNewItem: any): any => {
                    if (smItem === smNewItem[_smallGroupFlag] && smNewItem[middleGroupFlag] === smallItem && smallFirstRow) {
                      let rowSpanTag = smallRow;
                      this.addRowSpan(rowSpanTag, smNewItem, length);
                      orderFirstRow = false;
                    }
                  }
                );
              }
            );
          }
        );
      }
    );
    return newArry;
  }

  public addRowSpan(arr: any, tag: any, length: number): void {
    if (arr.length === 0) {
      return;
    }
    arr.forEach(
      (items: any): any => {
        if (length > 1) {
          this.$set(tag['_attributes']['rowSpan'], items, length);
        }
      }
    );
  }

  public formatterList(arr: any, key1: any, key2: any, key3: any): any {
    let arry: any = [];
    if (arr && arr.length > 0) {
      arr.forEach(
        (item: any): any => {
          item[key1].forEach(
            (item1: any): any => {
              item1[key2].forEach(
                (item2: any): any => {
                  item2[key3].forEach(
                    (item3: any): any => {
                      let obj: any = {};
                      Object.keys(item).forEach(
                        (name: any): any => {
                          if (name !== key1) {
                            obj[name] = item[name];
                          }
                        }
                      );
                      Object.keys(item1).forEach(
                        (name1: any): any => {
                          if (name1 !== key2) {
                            obj[name1] = item1[name1];
                          }
                        }
                      );
                      Object.keys(item2).forEach(
                        (name2: any): any => {
                          if (name2 !== key3) {
                            obj[name2] = item2[name2];
                          }
                        }
                      );
                      Object.keys(item3).forEach(
                        (name3: any): any => {
                          obj[name3] = item3[name3];
                        }
                      );
                      this.$set(obj, '_attributes', {});
                      this.$set(obj['_attributes'], 'rowSpan', {});
                      arry.push(obj);
                    }
                  );
                }
              );
            }
          );
        }
      );
      return arry;
    }
  }

  public changeStatusProc(targetStatusType: any, checkedRowList: any, successAlert: any, grid: any, orderStatusType: any, search: any): any {
    // const isPayConfirm = targetStatusType === 'PAY_DONE' && (orderStatusType === 'DEPOSIT_WAIT' || holdByReservation);//alpha页面中隐藏的input 可以获得holdByReservation值
    if (targetStatusType === 'DELIVERY_ING') {
      let hasInvoiceInfos = true;
      $.each(
        checkedRowList,
        (index, value): any => {
          if (!value.deliveryCompanyType) {
            value.deliveryCompanyType = $((grid as any).getElement(value.rowKey, 'deliveryCompanyType'))
              .find('select')
              .val();
          }
          if (value.deliveryType === 'PARCEL_DELIVERY' && value.delivery === true && (value.deliveryCompanyType === null || value.invoiceNo === null)) {
            hasInvoiceInfos = false;
          }
        }
      );
      if (!hasInvoiceInfos) {
        alert(this.$t('ORDER_LIST_GRIDS_INVOICE_NO_EMPTY_ALERT'));
        return;
      }
    }
    const flag = checkedRowList
      .map(
        (row: any): any => {
          return row.taskMessage;
        }
      )
      .every(
        (value: any): any => {
          return value === false;
        }
      );
    if (orderStatusType === 'PRODUCT_PREPARE' || orderStatusType === 'DELIVERY_PREPARE') {
      let message = '';
      switch (targetStatusType) {
        case 'DELIVERY_PREPARE':
          message = this.$t('ORDER_LIST_GRIDS_MESSAGE_CONFIRM_1') as any;
          break;
        case 'PAY_DONE':
          message = this.$t('ORDER_LIST_GRIDS_MESSAGE_CONFIRM_2') as any;
          break;
        case 'DELIVERY_ING':
          message = this.$t('ORDER_LIST_GRIDS_MESSAGE_CONFIRM_3') as any;
          break;
        case 'PRODUCT_PREPARE':
          message = this.$t('ORDER_LIST_GRIDS_MESSAGE_CONFIRM_4') as any;
          break;
        default:
          break;
      }
      if (!flag && !confirm(message)) {
        return;
      }
    }
    let requestOp: any = checkedRowList.map(
      (item: any): any => {
        let deliveryCompany
        if(item.deliveryCompanyType === undefined){ // 배송사가 묶인 경우 첫번째 옵션만 deliveryCompanyType 할당되어짐. 같은 주문
          deliveryCompany = checkedRowList.find(checkedItem => checkedItem.shippingNo === item.shippingNo).deliveryCompanyType
        }

        return {
          deliveryCompanyType: item.deliveryCompanyType !== undefined ? item.deliveryCompanyType : deliveryCompany,
          invoiceNo: item.invoiceNo,
          mallNo: item.mallNo,
          orderOptionNo: item.orderProductOptionNo
        };
      }
    );
    let request: PutOrderOptionChangeStatusRequest = {
      data: {
        orderStatusType: targetStatusType,
        options: requestOp
      }
    };

    let requestCheckList: any = checkedRowList.map(
      (item: any): any => {
        return {
          orderOptionNo: item.orderProductOptionNo
        };
      }
    );

    let requestCheckDivide: PostOrderOptionsCheckDivideShippingRequest = {
      data: {
        options: requestCheckList
      }
    };
    this.$api.postOrderOptionsCheckDivideShipping(requestCheckDivide).then((res): any => {
      // NOTE 배송준비중 > 그리드 內 [출고] 버튼 선택 시, 나눔배송 처리되지 않고 정상적으로 출고 처리되어야 함
      // if(targetStatusType === 'DELIVERY_ING') {
      //   if(res.data.result === true) {
      //     if (!confirm(this.$t('ORDER_LIST_GRIDS_DIVIDE_DELIVERY_CONFIRM') as string)) {
      //       return;
      //     }
      //   }
      // }
      this.$api.putOrderOptionChangeStatus(request).then((): any => {
        if (successAlert) {
          alert(this.$t('ORDER_LIST_GRIDS_HANDLE_DONE'));
        }
        search(1, this.size);
      });
    });
  }

  public doHoldDelivery(orderStatusType: OrderStatusType, search: any): void {
    if ((this.$refs.gridBottom as any).getCheckedRowKeys().length === 0) {
      alert(this.$t('ORDER_LIST_GRIDS_NOT_CHECK_ROW_ALERT'));
      return;
    }
    const checkList: any = (this.$refs.gridBottom as any).getCheckedRowKeys();
    const flag = checkList.map((row: any): any => (this.$refs.gridBottom as any).getRowItems(row).taskMessage).every((value: any): any => value === false);
    let message: any = '';
    const nextAction = orderStatusType == 'DELIVERY_PREPARE' ? this.$t('ORDER_LIST_GRIDS_DELIVERY_TAG') : this.$t('ORDER_LIST_GRIDS_OUT_STORE_TAG');
    if (!flag) {
      message = this.$t('ORDER_LIST_GRIDS_PRODUCT_PREPARE_CHANGE_STATUS_CONFIR_1', {str: nextAction});
    } else {
      message = this.$t('ORDER_LIST_GRIDS_PRODUCT_PREPARE_CHANGE_STATUS_CONFIR_2', {str: nextAction});
    }

    if (!confirm(message)) {
      return;
    }
    const orderOptionNos = (this.$refs.gridBottom as any).getCheckedItems(['orderProductOptionNo']);
    let holdDeliveryRequest: PutOrderOptionHoldDeliveryRequest = {
      params: {
        orderOptionNos: orderOptionNos.join(',')
      },
      data: {}
    };
    this.$api.putOrderOptionHoldDelivery(holdDeliveryRequest).then((): any => {
      alert(this.$t('ORDER_LIST_GRIDS_HANDLE_DONE'));
      search(1, this.size);
    });
  }

  public getDisabled(name: string): boolean {
    let disabled: boolean;
    let routeName = this.getRouteName(this.label)
    disabled = routeName.includes(name);
    return disabled;
  }

  public getRouteName(name): string[] {
    switch (name) {
      case 'OrderList':
      case 'OrderListDeposit':
        return ['platformType'];

      case 'OrderHoldDelivery':
        return ['holdDeliveryYmdt'];

      case 'OrderHoldByReservation':
        return ['reservationStartYmdt'];

      default:
        return [''];
    }
  }

  public defaultDisplay = [
    {columnName: 'platformType', i18n: '플랫폼구분'},
    {columnName: 'mallNo', i18n: '쇼핑몰구분'},
    {columnName: 'orderRegisterType', i18n: '주문구분'},
    {columnName: 'reservation', i18n: '예약주문'},
    {columnName: 'memberGroupInfoJson', i18n: '회원그룹'},
    {columnName: 'payType', i18n: '결제수단'},
    {columnName: 'orderNo', i18n: '주문번호'},
    {columnName: 'ordererName', i18n: '주문자명'},
    {columnName: 'ordererContact1', i18n: '주문자 연락처'},
    {columnName: 'memberNo', i18n: '회원번호'},
    {columnName: 'holdDelivery', i18n: '배송보류'},
    {columnName: 'shippingAreaType', i18n: '배송구분'},
    {columnName: 'taskMessage', i18n: '업무메시지'},
    {columnName: 'orderStatusType', i18n: '주문상태'},
    {columnName: 'orderStatusType', i18n: '구분'},
    {columnName: 'claimStatusType', i18n: '클레임상태'},
    {columnName: 'partnerNo', i18n: '파트너사'},
    {columnName: 'hsCode', i18n: 'HS CODE'},
    {columnName: 'mallProductNo', i18n: '상품번호'},
    {columnName: 'productManagementCd', i18n: '상품관리코드'},
    {columnName: 'imageUrl', i18n: '상품 이미지'},
    {columnName: 'productName', i18n: '상품명'},
    {columnName: 'productNameEn', i18n: '영문상품명'},
    {columnName: 'optionManagementCd', i18n: '옵션관리코드'},
    {columnName: 'displayOptionName', i18n: '옵션명'},
    {columnName: 'displayOptionName', i18n: '옵션명: 옵션값'},
    {columnName: 'immediateDiscountedPrice', i18n: '판매가(할인적용가)'},
    {columnName: 'additionalDiscountAmt', i18n: '추가할인'},
    {columnName: 'buyPrice', i18n: '추가할인적용가'},
    {columnName: 'freeGiftDiscountAmt', i18n: '사은품 할인'},
    {columnName: 'orderCnt', i18n: '수량'},
    {columnName: 'totalBuyAmt', i18n: '상품합계'},
    {columnName: 'receiverName', i18n: '수령자명'},
    {columnName: 'receiverContact1', i18n: '수령자휴대전화'},
    {columnName: 'receiverZipCd', i18n: '우편번호'},
    {columnName: 'address', i18n: '주소'},
    {columnName: 'shippingNo', i18n: '배송번호'},
    {columnName: 'deliveryAmtInAdvance', i18n: '결제방식'}, // 배송비 결제방식
    {columnName: 'deliveryAmtInAdvance', i18n: '배송비 결제방식'}, // 배송비 결제방식
    {columnName: 'deliveryConditionType', i18n: '배송비 유형'},
    {columnName: 'customsIdNumber', i18n: '개인통관고유부호'},
    {columnName: 'deliveryType', i18n: '배송방법'},
    {columnName: 'deliveryCompanyType', i18n: '택배사'},
    {columnName: 'deliveryCompanyType', i18n: '택배사선택'},
    {columnName: 'invoiceNo', i18n: '송장번호'},
    {columnName: 'invoiceNo', i18n: '송장번호입력'},
    {columnName: 'liquor', i18n: '주류구매 정보동의'},
    {columnName: 'orderYmdt', i18n: '주문일시'},
    {columnName: 'payYmdt', i18n: '결제일시'},
    {columnName: 'orderAcceptYmdt', i18n: '주문접수일시'},
    {columnName: 'releaseReadyYmdt', i18n: '출고준비처리일시'},
    {columnName: 'releaseYmdt', i18n: '출고일시'},
    {columnName: 'deliveryCompleteYmdt', i18n: '배송완료일시'},
    {columnName: 'buyConfirmYmdt', i18n: '구매확정일시'},
    {columnName: 'recommenderId', i18n: '추천인'},
    {columnName: 'deliveryMemo', i18n: '배송메모'},
    {columnName: 'exchange', i18n: '교환여부'},
    {columnName: 'adjustedAmt', i18n: '기본배송비'},
    {columnName: 'deliveryAmt', i18n: '기본배송비'},
    {columnName: 'remoteDeliveryAmt', i18n: '지역별배송비'},
    {columnName: 'orderMemo', i18n: '주문메모'},
    {columnName: 'userInputTextStr', i18n: '구매자작성형'},
    {columnName: 'procEachBtn', i18n: '주문접수처리'},
    {columnName: 'procEachBtn', i18n: '입금확인처리'},
    {columnName: 'procEachBtn', i18n: '출고준비처리'},
    {columnName: 'procEachBtn', i18n: '배송완료처리'},
    {columnName: 'procEachBtn', i18n: '출고처리'},
    {columnName: 'holdDeliveryYmdt', i18n: '배송보류처리일시'},
    {columnName: 'reservationStartYmdt', i18n: '예약판매시작일'},
    {columnName: 'failInfo', i18n: '실패사유'},
    { columnName: 'orderOptionNo', i18n: '주문상품옵션번호' },
    {columnName: 'recurringPaymentNo', i18n: '정기결제(배송) 신청 번호'},
    { columnName: 'lastSubPayAmt', i18n: '적립금사용' },
    { columnName: 'lastMainPayAmt', i18n: '실결제금액' },
    { columnName: 'imageUrl', i18n: '상품 이미지' },
  ];

  public isEmpty(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    } else {
      return false;
    }
  }

  public setCommunicateFailBgColor(orderListContent, gridRef) {
		if (!orderListContent.length) return;
    const columnNames = difference(Object.keys(head(orderListContent)), mergedRows);

    orderListContent.forEach(order => {
      if (order.communicateFail) {
        setTimeout((): void => {
          (gridRef as any).addRowClassName(order.rowKey, 'fail-order');
        }, 100);
      }

      if (order.freeGiftConditionBrokenType === 'CLAIM_DONE') {
        this.$nextTick(() => {
          columnNames.forEach(name => gridRef.addCellClassName(order.rowKey, name, 'red'));
        })
      }

    });
  }
}
